<template>
    <div class="h-100">
        <b-container fluid>
            <h2 class="tw-mb-0 text-aegis-dk">
                Ento Collection
                <small>
                    <b-badge>
                        {{ collectionCode }}
                    </b-badge>
                </small>
            </h2>
            <p class="tw-italic tw-text-gray-700">
                Summary given a collection code.
            </p>
        </b-container>

        <hr />

        <b-container class="m-0">
            <b-card>
                <b-container fluid>
                    <b-row>
                        <b-col class="tw-p-2">Species</b-col>
                        <b-col class="tw-p-2">Unfed</b-col>
                        <b-col class="tw-p-2">Fed</b-col>
                        <b-col class="tw-p-2">Gravid</b-col>
                        <b-col class="tw-p-2">Half-Gravid</b-col>
                        <b-col class="tw-p-2">Male</b-col>
                    </b-row>

                    <b-row>
                        <b-col class="tw-p-2">An. gambiae s.l.</b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.gambiae_unfed"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.gambiae_fed"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.gambiae_gravid"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.gambiae_half_gravid"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.gambiae_male"
                                disabled
                            ></b-form-input>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col class="tw-p-2">An. funestus</b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.funestus_unfed"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.funestus_fed"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.funestus_gravid"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.funestus_half_gravid"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.funestus_male"
                                disabled
                            ></b-form-input>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col class="tw-p-2">An. coustani</b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.coustani_unfed"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.coustani_fed"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.coustani_gravid"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.coustani_half_gravid"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.coustani_male"
                                disabled
                            ></b-form-input>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col class="tw-p-2">Culex spp.</b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.culex_unfed"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.culex_fed"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.culex_gravid"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.culex_half_gravid"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.culex_male"
                                disabled
                            ></b-form-input>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col class="tw-p-2">Other spp.</b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.other_unfed"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.other_fed"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.other_gravid"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.other_half_gravid"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col class="tw-p-2">
                            <b-form-input
                                v-model="counts.other_male"
                                disabled
                            ></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row v-if="counts.uncategorized >= 1">
                        <b-col>
                            <hr>
                            <p class="tw-text-red-600">
                                NOTE: There are <strong>{{counts.uncategorized}}</strong> uncategorized entries. <strong>Species Morpho, Anoph Sex and Abdominal Status</strong> are needed to categorize entries.
                            </p>
                        </b-col>
                    </b-row>
                </b-container>
            </b-card>
        </b-container>
    </div>
</template>

<script>
import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import { mapState, mapGetters, mapActions } from "vuex";

import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import * as _ from "lodash";

export default {
    mixins: [DashboardBaseTemplate],
    props: {
        collectionCode: {
            type: String,
            required: true
        },
    },
    data: function () {
        return {
            message: null,
            counts: {}
        };
    },
    mounted: function () {
        this.loadData();
    },
    computed: {},
    watch: {},
    methods: {
        loadData: function () {
            const that = this;
            HTTP.get(`/kenya/ento-data-counts/?collection_code=${that.collectionCode}`)
                .then((response) => {
                    that.counts = response.data;
                })
                .catch((error) => {
                    if ("message" in error.response.data) {
                        that.message = error.response.data["message"];
                    }
                });
        },
    },
};
</script>

<style></style>
